import { GLDClosureTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGldLibraryFields } from "../../../schema/gld-schema-library";

export const getGldClosureSchema = (
  type: FormType | undefined
): SchemaForFormData<GLDClosureTask> => ({
  type: "object",
  title: `GLD-Beeindigen ${getTitleAddon(type)}`,
  description: `Dit is het GLD Beeindigen formulier. ${getDocsLinkMarkdown("GLD")}`,
  required: ["metadata"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty", "broId"],
      properties: pickGldLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
        "correctionReason",
      ]),
    },
  },
});
